import {useTranslation} from '@aboutyou/i18n';
import {useSearchRoute} from '@aboutyou/router';
import {useTrackFeature} from '@aboutyou/tracking';
import {
  COLORS,
  FONT_SIZES,
  FONT_WEIGHTS,
  GenericIconName,
  Icon,
  UnstyledLink,
} from '@aboutyou/ui-components';
import {styled as linariaStyled} from '@linaria/react';
import React from 'react';
import sc from 'styled-components';

export const LinkSearchBar = () => {
  const {t} = useTranslation();
  const trackFeature = useTrackFeature();
  const searchRoute = useSearchRoute();

  const onSearchBarClick = () => {
    trackFeature({eventType: 'click', label: 'searchBarInBurgerMenu'});
  };

  return (
    <SearchBarWrapper
      data-testid="headerSearchBar"
      onClick={onSearchBarClick}
      to={searchRoute}
      aria-label={undefined}
    >
      <StyledSearchIcon asset={GenericIconName.Search} size="SS" />
      <StyledPlaceholder>
        {t('Search for items, brands and more...')}
      </StyledPlaceholder>
    </SearchBarWrapper>
  );
};

const SearchBarWrapper = sc(UnstyledLink)`
  display: flex;
  align-items: center;
  border-radius: 0.25rem;
  height: 48px;
  background: ${COLORS.Grey4};
  margin-top: 1rem;
`;

const StyledSearchIcon = linariaStyled(Icon)`
  cursor: pointer;
  margin: 0 8px;
`;

const StyledPlaceholder = sc.div`
  color: ${COLORS['Fill.Grey.Inactive']};
  font-size: ${FONT_SIZES.px14};
  font-weight: ${FONT_WEIGHTS.mediumBold};
`;
